import React from 'react';
import '@fortawesome/fontawesome-free/css/all.min.css';
import SectionHero from '../Helpers/SectionHero';
import SectionCTA from '../Helpers/SectionCTA';
import ServiceCard from '../Helpers/ServiceCard';
import marketingImg from '../../assets/images/services/marketing_analytics.png';
import salamandra from '../../assets/images/logos/megafono.png';
import { useLanguage } from '../../i18n/LanguageContext';

// Metadata (íconos) de los bloques; el texto viene de t('marketing.blocks').
const blockIcons = ['fa-palette', 'fa-bullhorn', 'fa-magnifying-glass-chart', 'fa-users-gear'];

const Marketing = () => {
    const { t } = useLanguage();
    const blocks = t('marketing.blocks').map((b, i) => ({ ...b, icon: blockIcons[i] }));

    return (
        <>
            {/* Hero */}
            <SectionHero badge={t('marketing.badge')} title={t('marketing.title')} image={marketingImg} imageContain mascot={salamandra}>
                <p className="text-blue-100 text-lg md:text-xl">
                    {t('marketing.subtitle')}
                </p>
            </SectionHero>

            {/* Bloques de servicios — fondo claro, lenguaje visual alineado al inicio */}
            <section
                className="relative overflow-hidden py-24"
                style={{ background: 'linear-gradient(180deg, #f8fafc 0%, #eef3f8 100%)' }}
            >
                {/* Textura de puntos (decorativa, esquina superior derecha) */}
                <div
                    className="dot-grid pointer-events-none absolute top-10 right-8 w-44 h-32 opacity-60 hidden md:block"
                    style={{ maskImage: 'linear-gradient(225deg, #000, transparent 75%)', WebkitMaskImage: 'linear-gradient(225deg, #000, transparent 75%)' }}
                ></div>

                <div className="contain relative z-10">
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-8 items-stretch">
                        {blocks.map((block, index) => (
                            <ServiceCard
                                key={index}
                                index={index}
                                icon={block.icon}
                                subtitle={block.subtitle}
                                title={block.title}
                                text={block.text}
                                delay={index * 100}
                                titleClass="text-2xl"
                            />
                        ))}
                    </div>
                </div>
            </section>

            {/* CTA */}
            <SectionCTA
                title={t('marketing.ctaTitle')}
                text={t('marketing.ctaText')}
                label={t('marketing.ctaLabel')}
            />
        </>
    );
};

export default Marketing;
